export const GYM = {
  name: "Fitness Point Gym",
  logoCircle: "/images/logo-circle.jpg",
  logoFigure: "/images/logo-figure.jpg",
  tagline: "Transform Your Body, Transform Your Life",
  location: "Kanba, Bichhiwara, Dungarpur",
  phone: "7878628977",
  whatsapp: "917878628977",
  instagram: "fitness_point_017",
  instagramUrl: "https://instagram.com/fitness_point_017",
  address: {
    line1: "Fitness Point Gym",
    line2: "Kanba, Bichhiwara",
    line3: "Dungarpur – 314804",
  },
  mapsUrl: "https://maps.app.goo.gl/nFVCyTkKRq4Tfuj4A",
  mapsEmbed:
    "https://www.google.com/maps?q=Fitness%20point%20gym%2C%20Bichhiwara%20-%20Dungarpur%20Rd%2C%20Kanba%2C%20Rajasthan&output=embed",
};

export const waLink = (msg) =>
  `https://wa.me/${GYM.whatsapp}?text=${encodeURIComponent(
    msg || "Hi! I want to join Fitness Point Gym. Please share the details."
  )}`;

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why" },
  { label: "Plans", href: "#plans" },
  { label: "Gallery", href: "#gallery" },
  { label: "Visit", href: "#visit" },
];

export const FEATURES = [
  {
    title: "Modern Equipment",
    desc: "Top-tier machines and free weights built for serious training.",
    icon: "Dumbbell",
  },
  {
    title: "Personal Training",
    desc: "One-on-one coaching with personalized guidance for your goals.",
    icon: "UserRoundCheck",
  },
  {
    title: "Weight Loss & Gain",
    desc: "Structured programs for fat loss, weight gain and body recomposition.",
    icon: "Scale",
  },
  {
    title: "Strength & Cardio",
    desc: "Build raw strength and endurance with focused training splits.",
    icon: "Flame",
  },
  {
    title: "Clean & Hygienic",
    desc: "A spotless, well-maintained space you'll actually enjoy training in.",
    icon: "Sparkles",
  },
  {
    title: "Friendly Atmosphere",
    desc: "A motivating community that pushes you to show up every single day.",
    icon: "HeartHandshake",
  },
];

export const PLANS = [
  { name: "Monthly", price: "799", period: "/ month", tag: "Starter", featured: false },
  { name: "3 Months", price: "1999", period: "/ quarter", tag: "Popular", featured: false },
  { name: "6 Months", price: "3499", period: "/ half year", tag: "Value", featured: false },
  { name: "Yearly", price: "5999", period: "/ year", tag: "Best Value", featured: true },
];

export const GALLERY = [
  "/images/gym-1.jpg",
  "/images/gym-2.jpg",
  "/images/gym-3.jpg",
  "/images/gym-4.jpg",
];

export const HERO_BG = "/images/hero-bg.jpg";
export const ABOUT_IMG = "/images/gym-1.jpg";
